import { useUserStore } from "@/store/user";
import { useGlobalStore } from "@/store/global";
import { getUserInfo } from "@/api/user";
import { getCategory } from "@/api/home";

export const getGlobalUser = async (data: any) => {
  const token = data?.token || localStorage.getItem("token");
  const expiresAt = data?.expiresAt || Date.now() + 8 * 60 * 60 * 1000; // 8小时后过期
  const userStore = useUserStore();
  const user: any = await getUserInfo();
  if (user.code === 200) {
    userStore.setUserInfo(user.data || {});
    // 适配新网址
    localStorage.setItem("auth-storage", JSON.stringify({
      state: {
        isAuthenticated: true,
        expiresAt,
        isLoading: false,
        token: token,
        user: user?.data,
      },
      version: 0
    }));
    
  } else {
    userStore.setUserInfo({});
    localStorage.removeItem("token");
    // localStorage.removeItem("auth-storage");
  }
};

export const getCategoryList = async () => {
  const userStore = useUserStore();
  const res: any = await getCategory();
  userStore.setCategoryList(res.data || {});
};

export const setLoginModalIsShow = (val, data = {}) => {
  const globalStore = useGlobalStore();
  globalStore.setLoginModalIsShow(val, data as any);
};

export const setPageLoading = (val) => {
  const globalStore = useGlobalStore();
  globalStore.setPageLoading(val);
};
